// AvatarComponent.tsx
import React, { useEffect, useState, forwardRef } from 'react'
import { Avatar } from '@mui/material'
import { AssignmentInd } from '@mui/icons-material'

type AvatarComponentProps = {
  extension?: string
  avatar?: string
  alt?: string
  size?: number
  candidate?: boolean
}

const AvatarComponent = forwardRef<HTMLDivElement, AvatarComponentProps>((props, ref) => {
  const getFullAvatarData = (avatar?: string, extension?: string) => {
    if (!avatar) return undefined
    return extension === 'LINK' ? atob(avatar) : 'data:image/png;base64,' + avatar
  }

  const { extension, avatar, alt, size = 32, candidate, ...other } = props
  const [src, setSrc] = useState<string | undefined>(getFullAvatarData(avatar, extension))

  useEffect(() => {
    setSrc(getFullAvatarData(avatar, extension))
  }, [avatar, extension])

  return (
    <Avatar
      ref={ref}
      alt={alt}
      {...other}
      {...(src ? { src } : {})}
      sx={{
        boxShadow: 1,
        width: size,
        height: size,
        fontSize: size / 2,
        backgroundColor: !src ? '#656565' : 'transparent',
        color: '#ffffff',
      }}
    >
      {candidate ? (
        <AssignmentInd sx={{ width: size * 0.75, height: size * 0.75, color: '#ffffff' }} />
      ) : !src && alt ? (
        alt.charAt(0)
      ) : (
        ''
      )}
    </Avatar>
  )
})

export default AvatarComponent
